import { render } from "./EventCard.vue?vue&type=template&id=a5963ed2&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=a5963ed2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a5963ed2"

export default script